import React, {useEffect,useRef} from 'react';
import {Radio,RadioGroup,FormControlLabel} from '@material-ui/core'
 function EirPrepayPhoneToggle(props) {  
    // const radioPlan = useRef(null);
    // const radioPhone = useRef(null);    
     var clickEvent=true;
    //  useEffect(()=>{
    //     clickEvent=false;
    //     if(props.toggle==0){
    //         radioPlan.current.click();
    //     } else{
    //         radioPhone.current.click();
    //     }
    // },[]);
    return (             
          <div className='div-align'>
            {/* Removing this RadioGroup as there is new eshop page for new prepay Journey */}
            {/* <RadioGroup
                aria-label="Prepay Plan"
                name="phoneplan"
                className='radio-group-phone'
            >
            <FormControlLabel ref={radioPlan} className='trans-background margin-phone-radio'  value="/mobile/phones/prepay/" control={<Radio color="primary" onClick={handleChange} />} label="New eir Prepay"/>
            <FormControlLabel ref={radioPhone} className='trans-background ' value="/store/mobile/phones/prepay/" control={<Radio color="primary"  onClick={handleChange} />} label="Existing eir Prepay" />
            </RadioGroup>  */}
         </div>       
        ); 
        function handleChange(event) {  
            localStorage.setItem('prepay-phone-plan',event.target.getAttribute('value')); 
            toggleClass(event);    
            if(clickEvent)
                window.location.href=event.target.getAttribute('value');               
            else
                clickEvent=true;
        }
        function toggleClass(event) { 
            var arrow = document.createElement('SPAN');
            arrow.id='trianglePhoneSpan'
            arrow.classList.add('prepay-phone-arrow-down');
            if(document.getElementById('trianglePhoneSpan')!=null || document.getElementById('trianglePhoneSpan')!=undefined)
                    document.getElementById('trianglePhoneSpan').remove();
            radioPlan.current.classList.remove('pur-background');
            radioPhone.current.classList.remove('pur-background');
            event.target.parentNode.parentNode.parentNode.classList.add('pur-background');
            event.target.parentNode.appendChild(arrow);
        }
  }
  export default EirPrepayPhoneToggle;